import React from 'react';
import { TaskBoard } from '../TaskAllocation';

const TaskAllocation = ({ user, selectedCountry = 'all' }) => {
  return <TaskBoard user={user} selectedCountry={selectedCountry} />;
};

export default TaskAllocation;